module.exports = __webpack_public_path__ + "img/auth-wall.75a45ecf.jpg";